




























































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
// @ts-ignore
import store from "../../../store";
import DraggableHtmlElement from "../../../libs/draggable-html-element/DraggableHtmlElement";
import MinutesPicker from "./MinutesPicker.vue";
import EventApi from "../../../api/EventsApi";
import Timer from "./Timer.vue";
import TimerEnums from "../../../../enums/mode/TimerEnums";

@Component({
    components: {MinutesPicker},
    props: {}
})

export default class ToolsTimer extends Vue {
    @Prop({required: true}) private readonly coordinates!: {x: number, y: number};

    private panelInstance: DraggableHtmlElement|null = null;
    private isCollapsed: boolean = false;
    private newLeft: number = this.coordinates.x;
    private newTop: number = this.coordinates.y;
    private mode: string = TimerEnums.TIMER_MODE;
    private isTicking: boolean = false;

    mounted(): void
    {
        this.bindEvents();
        this.panelInstance = new DraggableHtmlElement(this.$refs.panel as HTMLElement);
    }

    beforeDestroy(): void
    {
        this.unbindEvents();
    }

    private bindEvents(): void
    {
        (this.$refs.panel as HTMLElement).addEventListener('dragEnd', this.dragEnd);
    }

    private unbindEvents(): void
    {
        (this.$refs.panel as HTMLElement).removeEventListener('dragEnd', this.dragEnd);
    }

    /**
     * Позиция эл-та не менялась, находится в начальных координатах
     * @private
     */
    private get isInDefaultPosition(): boolean
    {
        return this.newLeft === parseInt(this.position.left)
            && this.newTop === parseInt(this.position.top);
    }

    /**
     * Позиционирование дайсомета в лейауте с ситами на столе
     * @private
     */
    private get position(): {[key: string]: string}
    {
        return {
            left: `${this.coordinates.x}px`,
            top: `${this.coordinates.y}px`
        }
    }

    /**
     * Остановить таймер
     * @private
     */
    private stopTimer(): void
    {
        this.isTicking = false;
    }

    /**
     * Добавить минуты к таймеру
     * @param minutes
     * @private
     */
    private addMinutes(minutes: number): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        (this.$refs.timer as Timer).addMinutes(minutes);
    }

    /**
     * Закончили перетаскивание
     * @param e
     * @private
     */
    private dragEnd(e: any): void
    {
        this.newLeft = e.detail.left;
        this.newTop = e.detail.top;
    }

    /**
     * Свернуть/развернуть панель
     * @private
     */
    private collapsePanel(): void
    {
        this.isCollapsed = !this.isCollapsed;
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
    }

    /**
     * Закрыть панель
     * @private
     */
    private close(): void
    {
        this.$emit('close');
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
    }

    private runTimer(): void
    {
        (this.$refs.timer as Timer).runTimer();
        this.isTicking = true;
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
    }

    private pauseTimer(): void
    {
        (this.$refs.timer as Timer).pause();
        this.isTicking = false;
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
    }
}

